import {mixins} from "../app/mixin";

mixins.push({
    data() {
        return {
            isCardFlipped: new Array(window.referenceSmallCardLength).fill(false),
        };
    },
    methods: {
        flipCard(index) {
            this.isCardFlipped[index] = !this.isCardFlipped[index];
        }
    }
});